const getters = {
  platformChannel: state => state.base.platformChannel,
  defaultAreaList: state => state.base.defaultAreaList,
  defaultAreaListChildren: state => state.base.defaultAreaListChildren,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  userPhone: state => state.user.userPhone,
  editAddress: state => state.user.editAddress,
  userBalance: state => state.user.userBalance,
  onLineBalance: state => state.user.onLineBalance,
  categoryList: state => state.base.categorys,
  brandList: state => state.base.brands,
  sortList: state => state.base.sorts,
  priceList: state => state.base.prices,
  peopleList: state => state.base.peoples,
  changeList: state => state.base.changes
}
export default getters
